import { render } from "./CreditBundlePaymentCallback.vue?vue&type=template&id=32854bf4&ts=true"
import script from "./CreditBundlePaymentCallback.vue?vue&type=script&lang=ts"
export * from "./CreditBundlePaymentCallback.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__